import { useEffect } from "react";

const useForceRefresh = () => {
  useEffect(() => {
    const currentVersion = localStorage.getItem("app_version");
    const newVersion = process.env.REACT_APP_BUILD_TIMESTAMP || Date.now().toString(); // 🔥 Auto-generate version

    if (currentVersion !== newVersion) {
      console.log("🔄 New version detected! Refreshing UI...");
      localStorage.setItem("app_version", newVersion);
      window.location.reload(); // 🚀 Force reload to update UI
    }
  }, []);
};

export default useForceRefresh;
